<template>
  <section>
    <b-modal :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            ロボ作成
          </p>
        </header>
        <!-- 初期モード確認 -->
        <div class="card-content">
          <div class="step-01" v-if="step === 0">
            <div class="make-bot-button" @click="step=3">
              <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">ストアから作成</p>
              <p style="height: 200px; text-align: left;">ロボストアから作成するモードです。初心者向けで、すぐにロボを作成できます。</p>
              <img style="width: 100%; height: auto; object-fit: cover;" src="@/assets/template/create_store.png"/>
            </div>
            <div class="make-bot-button" @click="step=2">
              <p style="font-weight: bold; font-size: 18px; margin-bottom: 15px;">テンプレから作成</p>
              <p style="height: 200px; text-align: left;">保存されたテンプレートから作成するモードです。作成後自由に編集可能のため、中級者向けです。</p>
              <img style="width: 100%; height: auto; object-fit: cover;" src="@/assets/template/create_template.png"/>
            </div>
            <div class="make-bot-button" @click="step=1">
              <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">新規作成</p>
              <p style="height: 200px; text-align: left;">ロボを新しく作成するモードです。上級者向けになります。</p>
              <img style="width: ; height: auto; object-fit: cover;" src="@/assets/template/create_make.png"/>
            </div>
            <label for="file_upload" class="make-bot-button">
            <!-- <div class=""> -->
              <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">インポート</p>
              <p style="height: 200px; text-align: left;">ロボをインポートし作成します。</p>
              <img style="width: 100%; height: auto; object-fit: cover;" src="@/assets/template/create_import.png"/>
              <input type="file" id="file_upload" @change="excelBotImport">
            <!-- </div> -->
            </label>
          </div>
          <!-- 新規ロボ -->
          <div class="step-new-02" v-if="step === 1">
            <p style="text-align: left; margin: 10px; position: relative;">
              <b>ロボ名を入力してください</b>
              <button
                class="button is-primary"
                style="top: -75px; position: absolute; right: 0;"
                @click="step=0"><span class="mdi mdi-undo" style="margin-right: 10px;"></span>戻る</button>
            </p>
            <div style="width: 100%; padding: 24px;">
              <div style="display: flex; width: 100%;">
                <p style="width: 200px; text-align: left;">
                  名前：
                </p>
                <b-input style="width: calc(100% - 200px); margin-left: 24px;" v-model="inputs.name" maxlength="30"></b-input>
              </div>
              <div style="display: flex; width: 100%; margin-top: 16px;" v-if="user.isAgent">
                <p style="width: 200px; text-align: left;">
                  ミニロボの台数：<br>
                  <span style="font-size: x-small; color: #777">同じような返答をするロボを複数台作成する場合は１以上にしてください。（後ほど変更もできます。）</span>
                </p>
                <b-numberinput controls-position="compact"
                  min="0" max="150"
                  v-model="miniBotCount"
                  style="margin-left: 24px;">
                </b-numberinput>
              </div>
            </div>
            <hr>
            <button class="button is-primary is-fullwidth" @click="clickCreateChatBot()" :disabled="inputs.name==''||miniBotCount>150">
              作成する
            </button>
          </div>
          <!-- テンプレートからロボ作成 -->
          <div class="step-02" v-if="step === 2">
            <p style="text-align: left; margin: 10px; position: relative;">
              <b>ロボ名を入力してください</b>
              <button
                class="button is-primary"
                style="top: -75px; position: absolute; right: 0;"
                @click="step=0"><span class="mdi mdi-undo" style="margin-right: 10px;"></span>戻る</button>
            </p>
            <b-input style="width: calc(100% - 20px); padding-left: 20px;" v-model="inputs.name" maxlength="30"></b-input>
            <p style="text-align: left; margin: 10px;"><b>テンプレートから選択</b></p>
            <div style="width: 100%; height: 300px; display: flex;">
              <div class="template-box disp-scroll">
                <div class="template-item" @click="selectTemplate(s)" v-for="(s, idx) in stores" :key="idx">
                  <img class="img-icon" :src="s.icon" v-if="s.icon!==''"/>
                  <img class="img-icon" src="@/assets/template/robot.png" v-if="s.icon===''">
                  <div style="width: 50%; height: 95%;">
                    <p style="padding: 5px; font-size: 13px;">{{s.name}}</p>
                  </div>
                </div>
              </div>
              <div class="scenario-flow">
                <p style="border-bottom: solid thin #ccc; padding: 5px;">{{selectedName}}</p>
                <BluePrint ref="bp" class="blueprint disp-scroll"></BluePrint>
              </div>
            </div>
            <hr>
            <button class="button is-primary is-fullwidth" @click="clickCreateChatBot()" :disabled="selectedName=='No Name'">
              作成する
            </button>
          </div>
          <!-- ストアからロボ作成 - 01 -->
          <div class="step-03" v-if="step === 3">
            <p style="text-align: left; margin: 10px; width: 100%; position: relative;">
              <b>作りたいロボのカテゴリーをお選びください。</b>
              <button
                class="button is-primary"
                style="top: -75px; position: absolute; right: 0;"
                @click="step=0"><span class="mdi mdi-undo" style="margin-right: 10px;"></span>戻る</button>
            </p>
            <div class="make-bot-category-button" v-for="(i, index) in storeCategoryList" :key="index" @click="selectCategory(i.category_id)">
              <p style="font-weight: bold; font-size: 20px; margin-top:8px;">{{i.category_name}}</p>
            </div>
          </div>
          <!-- ストアからロボ作成 - 02 -->
          <div v-if="step === 4">
            <p style="text-align: left; margin: 10px; width: 100%; position: relative;">
              <button
                class="button is-primary"
                style="top: -75px; position: absolute; right: 0;"
                @click="step=3"><span class="mdi mdi-undo" style="margin-right: 10px;"></span>戻る</button>
            </p>
            <div style="font-weight: bold; font-size: 20px; text-align:left; float:left; margin-top:4px;">
              <p>カテゴリー：</p>
            </div>
            <div style="float:left">
              <b-select v-model="selected">
                <option
                    v-for="(i, index) in storeCategoryList"
                    :value="i.category_id"
                    :key="index"
                >
                {{ i.category_name }}
                </option>
            </b-select>
            </div>
            <div style="width: 100%; height:300px; display: flex;">
              <div class="category-box disp-scroll">
                <div v-if="selectCategoryBot.length==0" class="category-not-bot">このカテゴリーに属するロボはありません</div>
                <div class="category-item" @click="selectTemplate(s); selectCategoryFlg=true;" v-for="(s, idx) in selectCategoryBot" :key="idx" :class="{selected:selectedName==s.name}">
                  <img class="img-icon" :src="s.icon" v-if="s.icon!==''"/>
                  <img class="img-icon" src="@/assets/template/robot.png" v-if="s.icon===''">
                  <div style="width: 50%; height: 95%;">
                    <p style="padding: 5px; font-size: 13px;">{{s.name}}</p>
                  </div>
                </div>
                <div class="category-item none" v-if="selectCategoryBot.length%2!=0"></div>
              </div>
              <div class="scenario-flow">
                <p style="border-bottom: solid thin #ccc; padding: 5px;">{{selectedName}}</p>
                <BluePrint ref="bp" class="blueprint disp-scroll"></BluePrint>
              </div>
            </div>
            <hr>
            <p>作成するロボ名を入力</p>
            <b-input v-if="!selectCategoryFlg" disabled></b-input>
            <b-input v-else v-model="inputs.name" maxlength="30"></b-input>
            <hr>
            <button class="button is-primary is-fullwidth" @click="clickCreateChatBot()" :disabled="inputs.name==''">
              作成する
            </button>
          </div>
        </div> 
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import createUUID from '@/functions/createUUID'
import BluePrint from '@/views/DashBoard/ChatBot/BluePrint'
import BluePrintEdit from '@/views/DashBoard/ChatBot/BluePrintEdit'
export default {
  name: 'ModalCreateChatBot',
  components: {
    BluePrint,
    BluePrintEdit
  },
  computed: {
    ...mapState('chatbot', ['stores', 'chatbots', 'scenarioTable', 'copyScenarioTable', 'selectStore']),
    ...mapState('auth', ['user', 'storeCategory']),
  },
  data () {
    return {
      newValue: '既存',
      category: '',
      type: 0,
      selectedScenario: null,
      isCardModalActive: false,
      step: 0,
      stepEdit: 0,
      scenarioName: 'default',
      selectedName: 'No Name',
      inputs: {
        name: '',
        display_name: '',
        group: null,
        scenario_name: '',
        left: 0,
        used_hours: 0,
        order_num: 0,
        is_store: false,
        editor: []
      },
      categoryOthers: [],
      storeCategoryList: [],
      selectCategoryBot: [],
      selectCategoryFlg: false,
      selected: "",
      miniBotCount: 0
    }
  },
  watch: {
    isCardModalActive () {
      this.$store.dispatch('chatbot/selectTemplate', {
        scenario_list: []
      })
      if (this.isCardModalActive == false) this.step = 0
      this.storeOther ()
    },
    selected () {
      this.selectCategory(this.selected)
    }
  },
  mounted () {
    // 初期化
    this.miniBotCount = 0
  },
  methods: {
    fixdata (data) {
        let o = '',
            l = 0,
            w = 10240
        for (; l < data.byteLength / w; ++l) {
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
        }
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
        return o
    },
    excelBotImport (e) {
      console.debug('*** Start *** excelImport')
      let files = e.target.files || e.dataTransfer.files
      console.log(e.target.files)
      let reader = new FileReader()
      reader.onload = (e) => {
        var XLSX = require('xlsx')
        var Utils = XLSX.utils
        var arr = this.fixdata(e.target.result)
        var book = XLSX.read(btoa(arr), {
            type: 'base64',
            cellDates: true,
        })
        var urlListsSheet1 = book.Sheets['TOP']
        var urlListsSheet2 = book.Sheets['BOT']
        var henkan1 = Utils.sheet_to_json(urlListsSheet1)
        var version = henkan1.find(d=>d.__rowNum__==1)
        henkan1 = henkan1.filter(d=>d.__rowNum__!=1)
        version = version ? version['__EMPTY_9'] : ''
        var henkan2 = Utils.sheet_to_json(urlListsSheet2)
        var dataJson = {
          'version'  : version,
          'bot'      : henkan1,
          'scenario' : henkan2
        }
        this.$store.dispatch('chatbot/importBot', dataJson)
      }
      reader.readAsArrayBuffer(files[0])
      this.step = 0
      this.isCardModalActive = false
      console.debug('*** End *** excelImport')
    },
    randomSelectStore (category, type) {
      this.$store.dispatch('chatbot/randomSelectStore', {category: this.category, type: this.type})
    },
    selectTemplate (selected) {
      console.debug('*** Start *** selectTemplate')
      console.debug('selected.name: ' + selected.name)
      this.selectedName = selected.name
      this.$store.dispatch('chatbot/selectTemplate', selected)
      console.debug('*** End *** selectTemplate')
    },
    clickCreateChatBot () {
      this.inputs.scenario_name = createUUID()
      this.inputs.group = this.user.companyID
      this.inputs.editor.push(this.user.userHash)
      if (this.step > 3) this.inputs.is_store = true
      var id = this.inputs.scenario_name
      if (this.inputs.name !== '') {
        // 作成時のdisplay_nameはnameと同じものとする
        this.inputs.display_name = this.inputs.name
        let createChatbotTemp = this.inputs
        if (this.step >= 2) this.$store.dispatch('chatbot/copyScenarioTable')
        this.$store.dispatch('chatbot/createChatBot', createChatbotTemp)
          .then((d) => {
            if (this.copyScenarioTable.length > 0) {
              this.$store.dispatch('chatbot/importScenarioList', {scenarioName: id, scenarioTable: this.copyScenarioTable})
            }
            setTimeout(() => {
              this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.inputs.scenario_name })
              let cb = ''
              for (let chatbot of this.chatbots) {
                if (chatbot.scenario_name ==  this.inputs.scenario_name) {
                  cb = chatbot
                }
              }
              this.$store.dispatch('chatbot/selectChatbot', cb)
              this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + id)
            }, 700)
            for (let j = 0; j < this.miniBotCount; j++) {
              let createChatBotMiniTemp = {
                name            : d.name + Number(j+1),
                chatbot         : d.bot_id,
                target_url      : null,
                start_url       : null,
                working_hours   : d.working_hours,
                is_recruit      : false,
                is_permitted    : false,
                permit_users    : null,
                send_power      : 0,
                select_power    : 0,
                receive_power   : 0,
                subscribe_power : 0
              }
              this.$store.dispatch('chatbot/createChatBotMini', createChatBotMiniTemp)
            }
            this.inputs.name = ''
          })
        this.isCardModalActive = false
      } else {
        alert('ロボ名を入力してください')
      }
      console.debug('*** End *** clickCreateChatBot')
    },
    selectCategory (id) {
      var selectCategoryOne = []
      this.selectCategoryBot = []
      if (id == "other") {
        this.selected = id 
        this.selectCategoryBot = this.categoryOthers
      }
      else {
        for (var i in this.storeCategory) {
          if (this.storeCategory[i].category_id == id) {
            this.selectCategoryOne = this.storeCategory[i]
          }
        }
        for (var i in this.stores) {
          if (this.stores[i].category == id) {
            this.selectCategoryBot.push(this.stores[i])
          }
        }
        this.selected = this.selectCategoryOne.category_id
      }
      this.step = 4
      this.selectCategoryFlg = false
      this.selectTemplate("")
    },
    storeOther (){
      this.$store.dispatch("auth/getStoreCateogry").then(() => {
        this.storeCategoryList = []
        this.categoryOthers = []
        for (var i in this.storeCategory) {
          this.storeCategoryList.push({"category_id": this.storeCategory[i].category_id, "category_name": this.storeCategory[i].category_name})
        }     
        this.storeCategoryList.push({"category_id": "other", "category_name": "その他"})
        var categoryIdList = []
        for (var i in this.storeCategory) {
          categoryIdList.push(this.storeCategory[i].category_id)
        }
        for (var i in this.stores) {
          if (categoryIdList.indexOf(Number(this.stores[i].category)) == -1){
            this.categoryOthers.push(this.stores[i])
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.template-box {
  width: calc(50% - 10px);
  margin: 5px;
  padding: 10px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.template-item {
  margin: 10px;
  padding: 5px;
  width: calc(50% - 20px);
  border-radius: 5px;
  background: white;
  word-break: break-word;
  transition: 0.5s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.template-item:hover {
  transform: scale(1.05);
}
.scenario-flow {
  width: calc(50% - 10px);
  margin: 5px;
  height: 300px;
  position: relative;
  border: solid thin #ccc;
}
.official {
  font-size: 11.5px;
  margin-top: -5px;
  color: #777;
  display: flex;
  justify-content: center;
  border: solid thin #ccc;
  border-radius: 5px;
  line-height: 1.4;
}
.blueprint {
  height: 263px;
  width: 100%;
  display: block;
}
.img-icon {
  width:  80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  border: solid thin #ccc;
}
.make-bot-button {
  height: 400px;
  width: calc(25% - 30px);
  margin: 10px 10px;
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  color: white;
  position: relative;
  padding: 20px;
  border-radius: 15px;
  background-color: rgba(144, 37, 98);
  transition: 0.5s;
}
.make-bot-button > input {
  display: none;
}
.make-bot-button:hover {
  transform: scale(1.05);
}
.make-bot-category-button {
  height: 80px;
  width: calc(25% - 30px);
  margin: 10px 10px;
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  color: white;
  position: relative;
  padding: 20px;
  border-radius: 15px;
  background-color: rgba(144, 37, 98);
  transition: 0.5s;
}
.make-bot-category-button > input {
  display: none;
}
.make-bot-category-button:hover {
  transform: scale(1.05);
}
.step-01 {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.step-03 {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.category-box {
  width: calc(50% - 10px);
  height: 300px;
  margin: 5px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.category-item {
  width: calc(50% - 20px);
  margin: 10px;
  height: 96px;
  cursor: pointer;
  display: flex;
  padding: 5px;
  background: white;
  word-break: break-word;
  transition: 0.5s;
  border-radius: 5px;
  border:solid white;
  justify-content: center;
}
.category-item.none{
  cursor: default;
}
.category-item:hover {
  transform: scale(1.05);
}
.category-item.selected{
  border:solid rgba(144, 37, 98);
}
.category-not-bot {
  font-size: 20px;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalCreateChatBot.vue